const Database = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 4.16699C17.5 5.5477 14.1421 6.66699 10 6.66699C5.85786 6.66699 2.5 5.5477 2.5 4.16699M17.5 4.16699C17.5 2.78628 14.1421 1.66699 10 1.66699C5.85786 1.66699 2.5 2.78628 2.5 4.16699M17.5 4.16699V15.8337C17.5 17.217 14.1667 18.3337 10 18.3337C5.83333 18.3337 2.5 17.217 2.5 15.8337V4.16699M17.5 10.0003C17.5 11.3837 14.1667 12.5003 10 12.5003C5.83333 12.5003 2.5 11.3837 2.5 10.0003"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Database;
